var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      staticClass: "modal",
      attrs: {
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _vm._v(" Изъять ТМЦ "),
              _vm.isInitialized
                ? _c("span", { staticClass: "guid" }, [
                    _vm._v(" №" + _vm._s(_vm.item.guid) + " "),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "name" }, [
                _vm._v(" " + _vm._s(_vm.item.name || " ") + " "),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      !_vm.isInitialized && _vm.busy
        ? _c("Loader", {
            attrs: { label: "Данные загружаются", height: 249, active: true },
          })
        : _c("vee-observer", {
            attrs: { slim: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit, errors }) {
                  return [
                    _c(
                      "form",
                      {
                        staticClass: "form",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.submit)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "inputs" },
                          [
                            _c(
                              "div",
                              { staticClass: "inputs__row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "date-input" },
                                  [
                                    _c(
                                      "vee-provider",
                                      {
                                        attrs: {
                                          vid: "date",
                                          rules: "required|date",
                                          slim: "",
                                        },
                                      },
                                      [
                                        _c("Input", {
                                          ref: "calendar",
                                          attrs: {
                                            label: "Дата изъятия",
                                            placeholder: "00.00.0000",
                                            format: "DD.MM.YYYY, dddd",
                                            type: "date",
                                            icon: "calendar",
                                            error: errors.date,
                                            editable: true,
                                            "icon-right": true,
                                            "required-mark": true,
                                            "actually-normal-error-messages": true,
                                          },
                                          model: {
                                            value: _vm.form.date,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "date", $$v)
                                            },
                                            expression: "form.date",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("Input", {
                                  attrs: {
                                    "floating-label": "Кем изъят",
                                    type: "select",
                                    items: _vm.employees,
                                    searchable: true,
                                    clearable: true,
                                  },
                                  model: {
                                    value: _vm.form.employee,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "employee", $$v)
                                    },
                                    expression: "form.employee",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "vee-provider",
                              {
                                attrs: {
                                  vid: "comment",
                                  rules: "max:500",
                                  slim: "",
                                },
                              },
                              [
                                _c("InputOld", {
                                  attrs: {
                                    "floating-label": "Комментарий",
                                    type: "textarea",
                                    "max-length": "500",
                                    clearable: true,
                                  },
                                  model: {
                                    value: _vm.form.comment,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "comment", $$v)
                                    },
                                    expression: "form.comment",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("FileLoader", {
                              ref: "fileLoader",
                              attrs: {
                                actions: "loadFiles,preview",
                                format: "all",
                                limit: 10,
                              },
                              model: {
                                value: _vm.form.files,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "files", $$v)
                                },
                                expression: "form.files",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "actions" },
                          [
                            _c("Button", {
                              attrs: { label: "Отменить" },
                              on: { click: _vm.close },
                            }),
                            _c("Button", {
                              attrs: {
                                label: "Изъять",
                                color: "primary",
                                type: "submit",
                                disabled: _vm.busy,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }